
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { State, FileUploadStatus, FileLink, Msg, SelectedFile, FileValidationStatus } from "./Types.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { append, isEmpty, exists, filter, choose, singleton, tryFind, tryPick, map, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { FormState__startLoading, FormState_get_empty, ValidationResponse, ClientApiResponse$1, PostResponse$1_$reflection, EmptyResponse_$reflection } from "../../Shared/Shared.js";
import { isNullOrWhiteSpace, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { bind, defaultArg, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { validateInspectionResultsCmd, downloadInspectionResultsTemplate, importInspectionResultsCmd } from "../../Requests/Importer.js";
import { FSharpSet__Contains, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { onBlobReceived } from "../../CommunicationV2.js";

function createSelectedFile(file) {
    let copyOfStruct;
    return new SelectedFile((copyOfStruct = newGuid(), copyOfStruct), file, new FileValidationStatus(0, []));
}

function uploadDocumentCmd(fileId, rowIndex, entityId, inspectionResultId, isVisibleForUserRole, file) {
    const formData = new FormData();
    formData.append(file.name, file);
    formData.append("Name", file.name);
    formData.append("Description", "");
    formData.append("IsVisibleForUserRole", toString(isVisibleForUserRole));
    if (inspectionResultId == null) {
    }
    else {
        const id = inspectionResultId;
        formData.append("InspectionResultId", id);
    }
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
    })))), [concat("/api/tools/", entityId, ..."/files"), formData], (response_1) => (new Msg(8, [fileId, rowIndex, new ClientApiResponse$1(0, [response_1])])), (_arg) => (new Msg(8, [fileId, rowIndex, new ClientApiResponse$1(1, [new ValidationResponse(undefined, empty())])])));
}

function updateLinkStatus(fileId, rowIndex, status, files) {
    return map((sf) => {
        if (sf.Id !== fileId) {
            return sf;
        }
        else {
            const matchValue = sf.ValidationStatus;
            if (matchValue.tag === 1) {
                return new SelectedFile(sf.Id, sf.File, new FileValidationStatus(1, [map((link) => {
                    if (link.RowIndex === rowIndex) {
                        return new FileLink(link.RowIndex, link.InventoryNumber, link.EntityId, status);
                    }
                    else {
                        return link;
                    }
                }, matchValue.fields[0])]));
            }
            else {
                return sf;
            }
        }
    }, files);
}

function nextPendingLink(files) {
    return tryPick((sf) => {
        const matchValue = sf.ValidationStatus;
        if (matchValue.tag === 1) {
            return map_1((link_1) => [sf.Id, link_1.RowIndex], tryFind((link) => equals(link.UploadStatus, new FileUploadStatus(0, [])), matchValue.fields[0]));
        }
        else {
            return undefined;
        }
    }, files);
}

function startNextFileUpload(files) {
    const matchValue = nextPendingLink(files);
    if (matchValue == null) {
        return singleton((dispatch_1) => {
            dispatch_1(new Msg(9, []));
        });
    }
    else {
        const rowIndex = matchValue[1] | 0;
        const fileId = matchValue[0];
        return singleton((dispatch) => {
            dispatch(new Msg(7, [fileId, rowIndex]));
        });
    }
}

function linkFilesToRows(validationResult, files) {
    if (validationResult != null) {
        const result = validationResult;
        return map((sf) => {
            const normalizedFileName = (sf.File.name.normalize('NFC')).toLocaleLowerCase();
            let existingLinks;
            const matchValue_1 = sf.ValidationStatus;
            existingLinks = ((matchValue_1.tag === 1) ? matchValue_1.fields[0] : empty());
            const links_1 = choose((row_1) => map_1((toolId) => (new FileLink(row_1.RowIndex, row_1.InventoryNumber.trim(), toolId, defaultArg(map_1((l_1) => l_1.UploadStatus, tryFind((l) => (l.RowIndex === row_1.RowIndex), existingLinks)), new FileUploadStatus(0, [])))), row_1.ToolId), filter((row) => {
                if (row.ToolId == null) {
                    return false;
                }
                else {
                    return exists((docName) => {
                        const trimmed = (docName.trim().normalize('NFC')).toLocaleLowerCase();
                        if (!isNullOrWhiteSpace(trimmed)) {
                            return normalizedFileName === trimmed;
                        }
                        else {
                            return false;
                        }
                    }, row.DocumentFileNames);
                }
            }, result.Rows));
            return new SelectedFile(sf.Id, sf.File, isEmpty(links_1) ? (new FileValidationStatus(2, [])) : (new FileValidationStatus(1, [links_1])));
        }, files);
    }
    else {
        return files;
    }
}

function extractBlob(response, filename) {
    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response.blob().then((_arg) => (Promise.resolve([_arg, filename]))))));
}

function getBlob(response, filename) {
    return Cmd_OfPromise_either((tupledArg) => extractBlob(tupledArg[0], tupledArg[1]), [response, filename], (tupledArg_1) => (new Msg(12, [tupledArg_1[0], tupledArg_1[1]])), (Item_2) => (new Msg(13, [Item_2])));
}

export function init() {
    return [new State(undefined, false, undefined, empty(), false, FormState_get_empty()), Cmd_none()];
}

export function update(msg, state) {
    let matchValue;
    switch (msg.tag) {
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(undefined, false, response.fields[0].GlobalValidationMessage, state.SelectedFiles, state.IsVisibleForUserRole, state.FormState), Cmd_errorToast("importer.failed_imported_data")];
            }
            else {
                const validationResult = response.fields[0];
                return [new State(validationResult, false, state.ValidateErrorMessage, linkFilesToRows(validationResult, state.SelectedFiles), state.IsVisibleForUserRole, state.FormState), Cmd_none()];
            }
        }
        case 0:
            return [new State(state.ValidationResult, true, state.ValidateErrorMessage, state.SelectedFiles, state.IsVisibleForUserRole, state.FormState), (matchValue = state.ValidationResult, (matchValue == null) ? Cmd_none() : importInspectionResultsCmd(matchValue, (Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(13, [Item_3]))))];
        case 1: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(undefined, false, response_1.fields[0].GlobalValidationMessage, state.SelectedFiles, state.IsVisibleForUserRole, state.FormState), Cmd_errorToast("importer.failed_imported_data")];
            }
            else {
                const validationResult_2 = response_1.fields[0];
                if (exists((sf_1) => {
                    const matchValue_1 = sf_1.ValidationStatus;
                    if (matchValue_1.tag === 1) {
                        return !isEmpty(matchValue_1.fields[0]);
                    }
                    else {
                        return false;
                    }
                }, state.SelectedFiles)) {
                    const cmd = startNextFileUpload(state.SelectedFiles);
                    return [new State(validationResult_2, state.ImportActive, state.ValidateErrorMessage, state.SelectedFiles, state.IsVisibleForUserRole, FormState__startLoading(state.FormState)), cmd];
                }
                else {
                    return [new State(validationResult_2, false, state.ValidateErrorMessage, state.SelectedFiles, state.IsVisibleForUserRole, state.FormState), Cmd_successToast("importer.successfully_imported_data")];
                }
            }
        }
        case 4: {
            const existingFileNames = ofList(map((sf_2) => sf_2.File.name, state.SelectedFiles), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            return [new State(state.ValidationResult, state.ImportActive, state.ValidateErrorMessage, linkFilesToRows(state.ValidationResult, append(state.SelectedFiles, map(createSelectedFile, filter((f) => !FSharpSet__Contains(existingFileNames, f.name), msg.fields[0])))), state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        }
        case 5:
            return [new State(state.ValidationResult, state.ImportActive, state.ValidateErrorMessage, filter((sf_3) => (sf_3.Id !== msg.fields[0]), state.SelectedFiles), state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        case 6:
            return [new State(state.ValidationResult, state.ImportActive, state.ValidateErrorMessage, state.SelectedFiles, msg.fields[0], state.FormState), Cmd_none()];
        case 7: {
            const rowIndex = msg.fields[1] | 0;
            const fileId_1 = msg.fields[0];
            const file_1 = tryFind((sf_4) => (sf_4.Id === fileId_1), state.SelectedFiles);
            if (file_1 == null) {
                return [state, singleton((dispatch) => {
                    dispatch(new Msg(9, []));
                })];
            }
            else {
                const sf_5 = file_1;
                const matchValue_2 = sf_5.ValidationStatus;
                if (matchValue_2.tag === 1) {
                    const link = tryFind((l) => (l.RowIndex === rowIndex), matchValue_2.fields[0]);
                    if (link == null) {
                        return [state, startNextFileUpload(state.SelectedFiles)];
                    }
                    else {
                        const link_1 = link;
                        const inspectionResultId = bind((vr) => bind((r_1) => map_1((id) => id, r_1.InspectionResultId), tryFind((r) => (r.RowIndex === rowIndex), vr.Rows)), state.ValidationResult);
                        return [new State(state.ValidationResult, state.ImportActive, state.ValidateErrorMessage, updateLinkStatus(fileId_1, rowIndex, new FileUploadStatus(1, []), state.SelectedFiles), state.IsVisibleForUserRole, state.FormState), uploadDocumentCmd(fileId_1, rowIndex, link_1.EntityId, inspectionResultId, state.IsVisibleForUserRole, sf_5.File)];
                    }
                }
                else {
                    return [state, startNextFileUpload(state.SelectedFiles)];
                }
            }
        }
        case 8: {
            const updatedFiles_4 = updateLinkStatus(msg.fields[0], msg.fields[1], (msg.fields[2].tag === 1) ? (new FileUploadStatus(3, [])) : (new FileUploadStatus(2, [])), state.SelectedFiles);
            return [new State(state.ValidationResult, state.ImportActive, state.ValidateErrorMessage, updatedFiles_4, state.IsVisibleForUserRole, state.FormState), startNextFileUpload(updatedFiles_4)];
        }
        case 9: {
            const toast = exists((sf_6) => {
                const matchValue_3 = sf_6.ValidationStatus;
                if (matchValue_3.tag === 1) {
                    return exists((l_1) => equals(l_1.UploadStatus, new FileUploadStatus(3, [])), matchValue_3.fields[0]);
                }
                else {
                    return false;
                }
            }, state.SelectedFiles) ? Cmd_errorToast("importer.some_uploads_failed") : Cmd_successToast("importer.successfully_imported_data");
            return [new State(state.ValidationResult, false, state.ValidateErrorMessage, state.SelectedFiles, state.IsVisibleForUserRole, FormState_get_empty()), toast];
        }
        case 10:
            return [state, downloadInspectionResultsTemplate((tupledArg) => (new Msg(11, [tupledArg[0], tupledArg[1]])), (Item_6) => (new Msg(13, [Item_6])))];
        case 11:
            return [state, getBlob(msg.fields[0], msg.fields[1])];
        case 12: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 13:
            return [new State(state.ValidationResult, false, "importer.csv_validation_failure", state.SelectedFiles, state.IsVisibleForUserRole, state.FormState), Cmd_none()];
        default:
            return [new State(undefined, true, undefined, map((sf) => (new SelectedFile(sf.Id, sf.File, new FileValidationStatus(0, []))), state.SelectedFiles), state.IsVisibleForUserRole, state.FormState), validateInspectionResultsCmd(msg.fields[0], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(13, [Item_1])))];
    }
}

